import React from "react";



interface PopupProps {
  children?: React.ReactNode;
  title?: string;
  show?: boolean;
  btnMessage?: string;
  btnClass?: string;
  btnImage?: any;
  mainImage?: any;
  logoImage?: any;
  imageClick?: any;
  onClick?: any;
  className?: string;
}


const Popup: React.FC<PopupProps> = ({children, title, show, btnMessage, onClick, mainImage, logoImage, imageClick, btnImage, className, btnClass}) => {
  //const [marker, setMarker] = React.useState<google.maps.Marker>();

  if(!imageClick) {
    imageClick = ()=>{};
  }

  React.useEffect(() => {
    console.log('Popup loaded');
    return () => {
      console.log('Popup destroyed');
    };
  }, []);

  className += " popup-wrap";
  if(show) {
    className += " show";
  }

  function getYouTubeId(url) {
    if (!url || typeof url !== "string") return null;
    console.log('Checking for YouTube URL:', url);
    const match = url.match(
        /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/
    );
    console.log('YouTube ID match:', match);
    return match ? match[1] : null;
}

  let youtubeId = getYouTubeId(mainImage);

  return (
    <div className={className}>
    <div className="popup" onClick={(e)=>e.stopPropagation()}>
      {mainImage && (youtubeId ? (
        <iframe width="300" height="169" src={`https://www.youtube.com/embed/${youtubeId}`} frameBorder="0" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
      ) : (
        <img className="popup_image" src={mainImage} alt={title} onClick={imageClick} />
      ))}
      <h2 className="popup_title">{title}</h2>
      <div className="popup_content">{children}</div>
      {logoImage && <img className="popup_image_bottom" src={logoImage} alt={title} />}
      {(btnMessage || btnImage) && <button className={"btn "+btnClass} onClick={onClick}>
        {btnImage ? <img src={btnImage} alt={btnMessage} /> : btnMessage}
      </button>}
      
    </div>
    </div>
  );
};


export default Popup;